import React from 'react';
import ReactDOM from 'react-dom';


const Howtousenew = ({ howToUSE,move,rotate,zoom,exploreProductIn3D,langcode,returnTo3D }) => {

   const exploreClick = () => {
      document.getElementById('howToUSE').style.display = "none";
      document.getElementById('howTousePopup').style.display = "none";
      document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
      document.getElementsByClassName('HowToUseHeader')[0].style.color = "#006BBD";
      document.getElementById('howToUSE').style.zIndex = "-1";
      document.getElementById('howTousePopup').style.zIndex = "-1";

   };


   const mobHowToUseMain = {
      display: 'none',
      position: 'fixed',
      top: '0',
      height: '100vh',
      width: '100%',
      backgroundColor: 'white',
      zIndex: '2'
   }

   const mobAllthreeDiv = {
      textAlign: 'left',
      margin: '23px 0px 33px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: ['fr','fr-ca'].includes(langcode) ? '19px':'24px',
      lineHeight: '1.1',
      width: '350px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
   }

   const mobAllthreeDivs = {
      textAlign: 'left',
      margin: '57px 0px 33px 0px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: ['fr','fr-ca'].includes(langcode) ? '19px' : '24px',
      lineHeight: '1.1',
      width: '350px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
   }

   const mobExploreButtton = {
      position: 'absolute',
      left: '50%',
      top: '425px',
      transform: 'translate(-50%, 100%)',
      cursor: 'pointer',
      height: '54px',
      width: '253px',
      background: '#0076CE',
      borderRadius: '2px',
      alignItems: 'center',
      textAlign: 'center',

      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '1.1',
      color: '#FFFFFF',
      border: '0'

   }

   const mobHowToUseText = {
      position: 'absolute',
      left: '0',
      alignItems: 'center',
      textAlign: 'center',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '300',
      fontSize: '35px',
      lineHeight: '1.1',
      color: '#000000',
      width: '100%'
   }

   const mobHowToUse = {
      display: 'flex',
      flexWrap: 'wrap',
      position: 'absolute',
      left: '50%',
      top: '40%',
      transform: 'translate(-50%,-40%)',
   }

   return (
      <React.Fragment>
         {ReactDOM.createPortal(
            <div>
               <div id="howToUSE" style={mobHowToUseMain} className='mobHowToUse'>

                  <div style={mobHowToUse}>
                     <a className="closeUseMob" onClick={exploreClick}><img tabIndex="1" id="closeBtn" alt="closeBtn" src="./images/cross.svg" /></a>

                     <span style={mobHowToUseText} id="mobHowToUseText">{howToUSE ?? 'How to use'}</span>

                     <div style={mobAllthreeDivs} className="ipadPortraitAlienment"><span style={{ position: 'relative',top: '-28px',width: '113px',wordBreak: 'break-all' }} id="move_how_to_use">{move ?? 'move'}</span><img style={{ marginLeft: '62px', height: '76px', width: '166px' }} alt="moves" src="images/move.svg" /></div>
                     <div style={mobAllthreeDiv} className="ipadPortraitAlienment"><span style={{ position: 'relative',top: '-28px',width: '113px',wordBreak: ['fr','fr-ca','hu','it','nl','ru','es'].includes(langcode) ? 'normal' : 'break-all' }} id="rotate_how_to_use">{rotate ?? 'rotate'}</span><img style={{ marginLeft: '57px', height: '76px', width: '166px' }} alt="rotates" src="images/rotate.svg" /></div>
                     <div style={mobAllthreeDiv} className="ipadPortraitAlienment"><span style={{ position: 'relative',top: '-28px',width: '113px',wordBreak: ['de','fr','fr-ca','hu','it','nl','ru','es'].includes(langcode) ? 'normal' : 'break-all' }} id="zoom_how_to_use">{zoom ?? 'Zoom'}</span><img style={{ marginLeft: '62px', height: '76px', width: '166px' }} alt="zommss" src="images/zoom.svg" /></div>
                     <button type='button' style={mobExploreButtton} onClick={exploreClick} id="exploreButtton1">
                        {returnTo3D ?? 'Return to 3D View'}
                        <img style={{ height: '24px', width: '24px', position: 'relative', top: '6px', left: '12px' }}
                           alt="arrow" src="images/arrowIcon.png" />
                     </button>
                  </div>
               </div>

            </div>, document.getElementById('howTousePopup')
         )}
      </React.Fragment>

   )
}

export default Howtousenew;

